<template>
  <FulfillmentScreen
    :order="order"
    :title="`Verifying Order #${order.id}`"
    :back-route="route('deliveries.index')"
  >
    <template #table>
      <OrderLineItemsTable
        :order="order"
        :show-swap-controls="fulfillmentService.state.unrecognizedScanHasOccured"
      />
    </template>
    <template #receipt>
      <Receipt :order="order">
        <template #controls>
          <VerificationReceiptControls
            :order="order"
            :canComplete="fulfillmentService.state.canComplete"
            @verify="fulfillmentService.verifyOrder()"
          />
        </template>
      </Receipt>
    </template>
  </FulfillmentScreen>
</template>

<script setup>
import { provide } from 'vue'
import Receipt from '@/Pages/Fulfillment/Receipt.vue'
import OrderLineItemsTable from '@/Components/DataGrid/Tables/OrderLineItems'
import { FULFILLMENT_SERVICE } from '@/Composables/Fulfillment/constants'
import { useFulfillmentService, MODES } from '@/Composables/Fulfillment/fulfillment-service'
import VerificationReceiptControls from '@/Pages/Deliveries/ReceiptControls.vue'
import FulfillmentScreen from '@/Screens/FulfillmentScreen.vue'

const props = defineProps({
  order: {
    type: Object,
    required: true
  }
})

const fulfillmentService = useFulfillmentService({ order: props.order, mode: MODES.VERIFYING })
provide(FULFILLMENT_SERVICE, fulfillmentService)
</script>
